import Framework7React, { App as F7App, View } from "framework7-react";
import Framework7 from "framework7/lite";
import Dialog from "framework7/components/dialog";
import Popup from "framework7/components/popup";
import Sheet from "framework7/components/sheet";
import Toast from "framework7/components/toast";
import Preloader from "framework7/components/preloader";
import Progressbar from "framework7/components/progressbar";
import Swipeout from "framework7/components/swipeout";
import Tabs from "framework7/components/tabs";
import Panel from "framework7/components/panel";
import Input from "framework7/components/input";
import Checkbox from "framework7/components/checkbox";
import Chip from "framework7/components/chip";
import PullToRefresh from "framework7/components/pull-to-refresh";
import Fab from "framework7/components/fab";
import Swiper from "./framework7/swiper-core";
import Skeleton from "framework7/components/skeleton";
import Typography from "framework7/components/typography";
import { routes } from "./routes/routes";
import "framework7-icons";
import { useDispatch, useStore } from "react-redux";
import { useEffect } from "react";
import {
  createSessionId,
  getGroupStatus,
  refreshGroups,
  selectCurrentGroupId,
  showGroup,
} from "./redux/reducer/app-slice";
import { isInviteLinkPath } from "./utils/invite-link";
import OfflineBanner from "./features/offline-banner";
import UpdatePrompt from "./features/update-prompt";
import { useOutboxSync } from "./hooks/use-outbox-sync";
import { usePushSync } from "./hooks/use-push-sync";

Framework7.use([
  Dialog,
  Popup,
  Sheet,
  Toast,
  Preloader,
  Progressbar,
  Swipeout,
  Tabs,
  Panel,
  Input,
  Checkbox,
  Chip,
  PullToRefresh,
  Fab,
  Swiper,
  Skeleton,
  Typography,
  Framework7React,
]);
const App = () => {
  const dispatch = useDispatch();
  const store = useStore();
  useOutboxSync();
  usePushSync();

  useEffect(() => {
    dispatch(createSessionId());

    // Not on an invite link: the refresh would race the join.
    const groupId = selectCurrentGroupId(store.getState());
    if (groupId && !isInviteLinkPath(window.location.pathname)) {
      dispatch(getGroupStatus(groupId, true));
      dispatch(
        refreshGroups((groups = []) => {
          const stillSelected =
            selectCurrentGroupId(store.getState()) === groupId;
          if (stillSelected && !groups.some((g) => g.id === groupId)) {
            dispatch(showGroup(null));
          }
        }),
      );
    }
  }, [dispatch, store]);

  return (
    <F7App
      name="Split It"
      theme="auto"
      colors={{
        primary: "#d11799",
      }}
      mdColorScheme="vibrant"
      routes={routes}
      className="overwrites"
    >
      <View main browserHistory={true} browserHistorySeparator="" />
      <OfflineBanner />
      <UpdatePrompt />
    </F7App>
  );
};

export default App;
